import { Button, Group, Stack, Text } from "@mantine/core";
import { AlertError, EntityClientAction, FakeProgressBar, useExecuteExportProc } from "@mcurros2/microm";
import { IconCircleX } from "@tabler/icons-react";
import { useEffect } from "react";
import { Reportes } from "./Reportes";

export const ExportarExcelConsolidadoModal = ({ reportes, onClose }: { reportes: Reportes, onClose: () => void }) => {


    const proc = useExecuteExportProc(reportes, reportes.def.procs.repo_qryReportesDetallada);

    useEffect(() => {
        async function fetchData() {
            await proc.execute({
                c_cliente_id: reportes.def.columns.c_cliente_id.value,
                dt_fecha_desde: reportes.parentKeys.dt_fecha_desde,
                dt_fecha_hasta: reportes.parentKeys.dt_fecha_hasta,
                c_autorizacion_directa_status_id: reportes.parentKeys.c_autorizacion_directa_status_id,
                dt_fecha_realizado_desde: reportes.parentKeys.dt_fecha_realizado_desde,
                dt_fecha_realizado_hasta: reportes.parentKeys.dt_fecha_realizado_hasta,
            });
        }
        fetchData();
    }, [
        reportes.def.columns.c_cliente_id.value,
        reportes.parentKeys.dt_fecha_desde,
        reportes.parentKeys.dt_fecha_hasta,
        reportes.parentKeys.c_autorizacion_directa_status_id,
        reportes.parentKeys.dt_fecha_realizado_desde,
        reportes.parentKeys.dt_fecha_realizado_hasta
    ]);

    useEffect(() => {
        if (!proc.status.loading && proc.status.data) {
            reportes.API.downloadBlobFile(proc.status.data, `Reporte_Consolidado_${new Date().toISOString()}.xlsx`);
            onClose();
        }
    }, [proc.status]);

    return (
        <Stack>
            {proc.status.error &&
                <AlertError mb="xs">
                    {proc.status.error.status} {proc.status.error.message} {proc.status.error.statusMessage} {(proc.status.error.status === 400) && proc.status.error.errorBody}
                </AlertError>
            }
            {proc.status.loading &&
                <>
                    <Text>Generando archivo...</Text>
                    <FakeProgressBar />
                </>
            }
            {!proc.status.loading && proc.status.data &&
                <Text>Archivo exportado con éxito...</Text>
            }
            <Group mt="xs" position="right">
                {proc.status.loading &&
                    <Button variant="light" leftIcon={<IconCircleX size="1.5rem" />} onClick={async () => {
                        await Promise.resolve(proc.abort());
                        onClose();
                    }} >Cancelar</Button>
                }
                {!proc.status.loading &&
                    <Button variant="light" leftIcon={<IconCircleX size="1.5rem" />} onClick={async () => {
                        onClose();
                    }} >Cerrar</Button>
                }
            </Group>
        </Stack >
    )
};


export const ACTExportarExcelConsolidado: EntityClientAction = {
    name: 'ACTExportarExcelConsolidado',
    label: 'Exportar Excel Consolidado',
    title: <Text fw={700}>Exportar Excel</Text>,
    refreshOnClose: true,
    dontRequireSelection: true,
    showActionInViewMode: true,
    views: ['repo_brwBaseReportesDetallada'],
    onClick: async ({ entity, modal, element, onClose }) => {
        const reportes = entity as Reportes;

        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }

        await modal.open({
            modalProps: {
                title: <Text fw="700">Exportar Excel</Text>
            },
            focusOnClosed: element,
            content: <ExportarExcelConsolidadoModal reportes={reportes} onClose={() => modal.close()} />

        });

        return false;
    }

}